// ============================================================================
// AFFILIATE ASSIGNMENT CONSTANTS
// ============================================================================

export const GET_PLAYER_AFFILIATES_REQUEST = 'GET_PLAYER_AFFILIATES_REQUEST';
export const GET_PLAYER_AFFILIATES_SUCCESS = 'GET_PLAYER_AFFILIATES_SUCCESS';
export const GET_PLAYER_AFFILIATES_FAIL = 'GET_PLAYER_AFFILIATES_FAIL';
export const GET_PLAYER_AFFILIATES_RESET = 'GET_PLAYER_AFFILIATES_RESET';

export const ASSIGN_AFFILIATE_REQUEST = 'ASSIGN_AFFILIATE_REQUEST';
export const ASSIGN_AFFILIATE_SUCCESS = 'ASSIGN_AFFILIATE_SUCCESS';
export const ASSIGN_AFFILIATE_FAIL = 'ASSIGN_AFFILIATE_FAIL';
export const ASSIGN_AFFILIATE_RESET = 'ASSIGN_AFFILIATE_RESET';

export const UPDATE_AFFILIATE_ASSIGNMENT_REQUEST = 'UPDATE_AFFILIATE_ASSIGNMENT_REQUEST';
export const UPDATE_AFFILIATE_ASSIGNMENT_SUCCESS = 'UPDATE_AFFILIATE_ASSIGNMENT_SUCCESS';
export const UPDATE_AFFILIATE_ASSIGNMENT_FAIL = 'UPDATE_AFFILIATE_ASSIGNMENT_FAIL';
export const UPDATE_AFFILIATE_ASSIGNMENT_RESET = 'UPDATE_AFFILIATE_ASSIGNMENT_RESET';

export const REMOVE_AFFILIATE_ASSIGNMENT_REQUEST = 'REMOVE_AFFILIATE_ASSIGNMENT_REQUEST';
export const REMOVE_AFFILIATE_ASSIGNMENT_SUCCESS = 'REMOVE_AFFILIATE_ASSIGNMENT_SUCCESS';
export const REMOVE_AFFILIATE_ASSIGNMENT_FAIL = 'REMOVE_AFFILIATE_ASSIGNMENT_FAIL';
export const REMOVE_AFFILIATE_ASSIGNMENT_RESET = 'REMOVE_AFFILIATE_ASSIGNMENT_RESET';

export const GET_AFFILIATE_REFERRALS_REQUEST = 'GET_AFFILIATE_REFERRALS_REQUEST';
export const GET_AFFILIATE_REFERRALS_SUCCESS = 'GET_AFFILIATE_REFERRALS_SUCCESS';
export const GET_AFFILIATE_REFERRALS_FAIL = 'GET_AFFILIATE_REFERRALS_FAIL';
export const GET_AFFILIATE_REFERRALS_RESET = 'GET_AFFILIATE_REFERRALS_RESET';

// ============================================================================
// SESSION HOURS LOG CONSTANTS
// ============================================================================

export const LOG_SESSION_HOURS_REQUEST = 'LOG_SESSION_HOURS_REQUEST';
export const LOG_SESSION_HOURS_SUCCESS = 'LOG_SESSION_HOURS_SUCCESS';
export const LOG_SESSION_HOURS_FAIL = 'LOG_SESSION_HOURS_FAIL';
export const LOG_SESSION_HOURS_RESET = 'LOG_SESSION_HOURS_RESET';

export const GET_PLAYER_SESSION_HOURS_REQUEST = 'GET_PLAYER_SESSION_HOURS_REQUEST';
export const GET_PLAYER_SESSION_HOURS_SUCCESS = 'GET_PLAYER_SESSION_HOURS_SUCCESS';
export const GET_PLAYER_SESSION_HOURS_FAIL = 'GET_PLAYER_SESSION_HOURS_FAIL';
export const GET_PLAYER_SESSION_HOURS_RESET = 'GET_PLAYER_SESSION_HOURS_RESET';

export const VOID_SESSION_LOG_REQUEST = 'VOID_SESSION_LOG_REQUEST';
export const VOID_SESSION_LOG_SUCCESS = 'VOID_SESSION_LOG_SUCCESS';
export const VOID_SESSION_LOG_FAIL = 'VOID_SESSION_LOG_FAIL';
export const VOID_SESSION_LOG_RESET = 'VOID_SESSION_LOG_RESET';

// ============================================================================
// COMMISSION TIER CONSTANTS
// ============================================================================

export const GET_COMMISSION_TIERS_REQUEST = 'GET_COMMISSION_TIERS_REQUEST';
export const GET_COMMISSION_TIERS_SUCCESS = 'GET_COMMISSION_TIERS_SUCCESS';
export const GET_COMMISSION_TIERS_FAIL = 'GET_COMMISSION_TIERS_FAIL';
export const GET_COMMISSION_TIERS_RESET = 'GET_COMMISSION_TIERS_RESET';

export const CREATE_COMMISSION_TIER_REQUEST = 'CREATE_COMMISSION_TIER_REQUEST';
export const CREATE_COMMISSION_TIER_SUCCESS = 'CREATE_COMMISSION_TIER_SUCCESS';
export const CREATE_COMMISSION_TIER_FAIL = 'CREATE_COMMISSION_TIER_FAIL';
export const CREATE_COMMISSION_TIER_RESET = 'CREATE_COMMISSION_TIER_RESET';

export const UPDATE_COMMISSION_TIER_REQUEST = 'UPDATE_COMMISSION_TIER_REQUEST';
export const UPDATE_COMMISSION_TIER_SUCCESS = 'UPDATE_COMMISSION_TIER_SUCCESS';
export const UPDATE_COMMISSION_TIER_FAIL = 'UPDATE_COMMISSION_TIER_FAIL';
export const UPDATE_COMMISSION_TIER_RESET = 'UPDATE_COMMISSION_TIER_RESET';

export const DELETE_COMMISSION_TIER_REQUEST = 'DELETE_COMMISSION_TIER_REQUEST';
export const DELETE_COMMISSION_TIER_SUCCESS = 'DELETE_COMMISSION_TIER_SUCCESS';
export const DELETE_COMMISSION_TIER_FAIL = 'DELETE_COMMISSION_TIER_FAIL';
export const DELETE_COMMISSION_TIER_RESET = 'DELETE_COMMISSION_TIER_RESET';

export const SEED_DEFAULT_TIERS_REQUEST = 'SEED_DEFAULT_TIERS_REQUEST';
export const SEED_DEFAULT_TIERS_SUCCESS = 'SEED_DEFAULT_TIERS_SUCCESS';
export const SEED_DEFAULT_TIERS_FAIL = 'SEED_DEFAULT_TIERS_FAIL';
export const SEED_DEFAULT_TIERS_RESET = 'SEED_DEFAULT_TIERS_RESET';

// ============================================================================
// COMMISSION CALCULATION CONSTANTS
// ============================================================================

export const PREVIEW_COMMISSION_REQUEST = 'PREVIEW_COMMISSION_REQUEST';
export const PREVIEW_COMMISSION_SUCCESS = 'PREVIEW_COMMISSION_SUCCESS';
export const PREVIEW_COMMISSION_FAIL = 'PREVIEW_COMMISSION_FAIL';
export const PREVIEW_COMMISSION_RESET = 'PREVIEW_COMMISSION_RESET';

export const CALCULATE_COMMISSION_REQUEST = 'CALCULATE_COMMISSION_REQUEST';
export const CALCULATE_COMMISSION_SUCCESS = 'CALCULATE_COMMISSION_SUCCESS';
export const CALCULATE_COMMISSION_FAIL = 'CALCULATE_COMMISSION_FAIL';
export const CALCULATE_COMMISSION_RESET = 'CALCULATE_COMMISSION_RESET';

export const GET_PENDING_COMMISSIONS_REQUEST = 'GET_PENDING_COMMISSIONS_REQUEST';
export const GET_PENDING_COMMISSIONS_SUCCESS = 'GET_PENDING_COMMISSIONS_SUCCESS';
export const GET_PENDING_COMMISSIONS_FAIL = 'GET_PENDING_COMMISSIONS_FAIL';
export const GET_PENDING_COMMISSIONS_RESET = 'GET_PENDING_COMMISSIONS_RESET';

export const APPROVE_COMMISSION_REQUEST = 'APPROVE_COMMISSION_REQUEST';
export const APPROVE_COMMISSION_SUCCESS = 'APPROVE_COMMISSION_SUCCESS';
export const APPROVE_COMMISSION_FAIL = 'APPROVE_COMMISSION_FAIL';
export const APPROVE_COMMISSION_RESET = 'APPROVE_COMMISSION_RESET';

export const REJECT_COMMISSION_REQUEST = 'REJECT_COMMISSION_REQUEST';
export const REJECT_COMMISSION_SUCCESS = 'REJECT_COMMISSION_SUCCESS';
export const REJECT_COMMISSION_FAIL = 'REJECT_COMMISSION_FAIL';
export const REJECT_COMMISSION_RESET = 'REJECT_COMMISSION_RESET';

export const BULK_APPROVE_COMMISSIONS_REQUEST = 'BULK_APPROVE_COMMISSIONS_REQUEST';
export const BULK_APPROVE_COMMISSIONS_SUCCESS = 'BULK_APPROVE_COMMISSIONS_SUCCESS';
export const BULK_APPROVE_COMMISSIONS_FAIL = 'BULK_APPROVE_COMMISSIONS_FAIL';
export const BULK_APPROVE_COMMISSIONS_RESET = 'BULK_APPROVE_COMMISSIONS_RESET';

// ============================================================================
// POTENTIAL AFFILIATES LIST (for dropdown)
// ============================================================================

export const GET_POTENTIAL_AFFILIATES_REQUEST = 'GET_POTENTIAL_AFFILIATES_REQUEST';
export const GET_POTENTIAL_AFFILIATES_SUCCESS = 'GET_POTENTIAL_AFFILIATES_SUCCESS';
export const GET_POTENTIAL_AFFILIATES_FAIL = 'GET_POTENTIAL_AFFILIATES_FAIL';
export const GET_POTENTIAL_AFFILIATES_RESET = 'GET_POTENTIAL_AFFILIATES_RESET';
